module.exports = {
  valuePropTourEvents: {
    NewUnifiedFlow: {
      code: 'ValuePropTour',
      events: {
        PageLoad: {
          description: 'Triggered when a value prop page is loaded',
          eventHub: {
            code: 'PageLoad',
            action: 'RUF-ValueProp[$.page]-PageLoad',
            dataKeys: []
          },
          ga: {
            action: 'RUF-ValueProp[$.page]-PageLoad'
          }
        },
        ClickNext: {
          description: 'Triggered when the next button is clicked (desktop) or swiped (mobile)',
          eventHub: {
            code: 'ClickNext',
            action: 'RUF-ValueProp[$.page]-ClickNext',
            dataKeys: []
          },
          ga: {
            action: 'RUF-ValueProp[$.page]-ClickNext'
          }
        },
        ClickPrev: {
          description: 'Triggered when the prev button is clicked (desktop) or swiped (mobile)',
          eventHub: {
            code: 'ClickPrev',
            action: 'RUF-ValueProp[$.page]-ClickPrev',
            dataKeys: []
          },
          ga: {
            action: 'RUF-ValueProp[$.page]-ClickPrev'
          }
        },
        ClickSignup: {
          description: 'Triggered when the signup button is clicked',
          eventHub: {
            code: 'ClickSignup',
            action: 'RUF-ValueProp-ClickSignup',
            dataKeys: []
          },
          ga: {
            action: 'RUF-ValueProp-ClickSignup'
          }
        },
        ClickFirstLearnMore: {
          description: 'Triggered when the 1st learn more CTA in value prop is clicked',
          eventHub: {
            code: 'ClickFirstLearnMore',
            action: 'RUF-ValueProp1_LearnMore',
            dataKeys: []
          }
        },
        ClickSecondLearnMore: {
          description: 'Triggered when the 2nd learn more CTA in value prop is clicked',
          eventHub: {
            code: 'ClickSecondLearnMore',
            action: 'RUF-ValueProp2_LearnMore',
            dataKeys: []
          }
        },
        ClickThirdLearnMore: {
          description: 'Triggered when the 3rd learn more CTA in value prop is clicked',
          eventHub: {
            code: 'ClickThirdLearnMore',
            action: 'RUF-ValueProp3_LearnMore',
            dataKeys: []
          }
        }
      }
    }
  }
};
